// Secure IDs generated by crypto used in nanoid is not supported in RN
import { nanoid } from 'nanoid/non-secure';
import { AdType } from '@zattoo/playback-sdk';
import { GT12AdType } from '../enums/index';
export const generateAdId = () => {
    return nanoid();
};
const GT_12_AD_TYPES = [
    AdType.START,
    AdType.FAST_FORWARD,
    AdType.PAUSE,
];
export const isGt12AdType = (videoAdType) => {
    return GT_12_AD_TYPES.includes(videoAdType);
};
export const sdkAdTypeToGT12TrackingAdType = (adType) => {
    switch (adType) {
        case AdType.START:
            return GT12AdType.START;
        case AdType.FAST_FORWARD:
            return GT12AdType.FAST_FORWARD;
        case AdType.PAUSE:
            return GT12AdType.PAUSE;
        default:
            return GT12AdType.UNKNOWN;
    }
};
